import React from 'react';
import ReactDOM from 'react-dom';

import Banner from '../Containers/Banner';



const banner = document.getElementsByClassName('banner')
for(let i = 0; i < banner.length; i++){
	const dataColumnLinks = JSON.parse(banner[i].getAttribute("data-column_links"));
	const title = banner[i].getAttribute("data-title");
	const text = banner[i].getAttribute("data-text");
	const sliderImages = JSON.parse(banner[i].getAttribute("data-slider"));
	const values = JSON.parse(banner[i].getAttribute("data-values"));
	const contacts = JSON.parse(banner[i].getAttribute("data-contacts"));
	ReactDOM.render(<Banner columnLinks={dataColumnLinks} title={title} text={text} slider={sliderImages} values={values} contacts={contacts} />, banner[i]);
}


// WEBPACK FOOTER //
// ./src/build/banner.js